import { IAnwswer } from "../../../interfaces/quiz";

function alternativeGenerate(index:number):string{
    if(index==0) return "A";
    if(index==1) return "B";
    if(index==2) return "C";
}

export default function alternativeBuilder(index:number,answer:IAnwswer):string{
    return `
        <div class="option-item" data-ans-code="${answer.ansCode}">
            <span class="label-alt">
                ${alternativeGenerate(index)}
            </span>
            <span class="label-text">
                ${answer.text}
            </span>
        </div>
    `;
}